import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import BillingSuccess from "src/features/payments/billing/BillingSuccess";
const BillingSuccessPage = () => {
    return (_jsx(_Fragment, { children: _jsx(BillingSuccess, {}) }));
};
export default BillingSuccessPage;
